<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>Nueva tira bordada</h3>
          <!-- <h4>Características básicas</h4> -->
          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <h4>Características</h4>

            <b-form-row>
              <b-col cols="12">
                <b-form-row>
                  <!-- Reference -->
                  <b-form-group
                    id="input-reference"
                    class="col-3"
                    label="Nombre de tira bordada"
                    label-for="reference"
                  >
                    <b-form-input
                      id="reference"
                      v-model="$v.form.reference.$model"
                      :state="validateState('reference')"
                      aria-describedby="input-reference-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-reference-feedback"
                      >Este campo es obligatorio.</b-form-invalid-feedback
                    >
                  </b-form-group>
                  <b-form-group
                    id="input-provider"
                    class="col-3"
                    label="Proveedor"
                    label-for="provider"
                  >
                    <b-form-input
                      id="provider"
                      v-model="$v.form.provider.$model"
                      :state="validateState('provider')"
                      aria-describedby="input-provider-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-provider-feedback"
                      >Este campo es obligatorio.</b-form-invalid-feedback
                    >
                  </b-form-group>
                  <b-form-group
                    id="input-ref_provider"
                    class="col-3"
                    label="Ref. proveedor"
                    label-for="ref_provider"
                  >
                    <b-form-input
                      id="ref_provider"
                      v-model="$v.form.ref_provider.$model"
                      :state="validateState('ref_provider')"
                      aria-describedby="input-ref_provider-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-ref_provider-feedback"
                      >Este campo es obligatorio.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-form-row>
                <b-form-row>
                  <!-- Medidas -->

                  <b-form-group
                    id="input-rapport_width"
                    class="col-4"
                    label="Medidas rapport (Ancho x Largo)"
                    label-for="rapport_width"
                    description="IA_ANCHO_TIRA_BORDADA"
                  >
                    <b-form-row>
                      <b-col :cols="6">
                        <b-input-group>
                          <b-form-input
                            id="rapport_width"
                            :value="
                              $v.form.rapport_width.$model.replace('.', ',')
                            "
                            @change="setDecimal('rapport_width', $event)"
                            :state="validateState('rapport_width')"
                            aria-describedby="input-rapport_width-feedback"
                          ></b-form-input>
                          <template #append>
                            <b-input-group-text>cm</b-input-group-text>
                          </template>
                        </b-input-group>
                        <b-form-invalid-feedback
                          id="input-rapport_width-feedback"
                          >Este campo es obligatorio.</b-form-invalid-feedback
                        >
                      </b-col>
                      <b-col :cols="6">
                        <b-input-group>
                          <b-form-input
                            id="rapport_long"
                            :value="
                              $v.form.rapport_long.$model.replace('.', ',')
                            "
                            @change="setDecimal('rapport_long', $event)"
                            :state="validateState('rapport_long')"
                            aria-describedby="input-rapport_long-feedback"
                          ></b-form-input>
                          <template #append>
                            <b-input-group-text>cm</b-input-group-text>
                          </template>
                        </b-input-group>
                        <b-form-invalid-feedback
                          id="input-rapport_long-feedback"
                          >Este campo es obligatorio.</b-form-invalid-feedback
                        >
                      </b-col>
                    </b-form-row>
                  </b-form-group>
                  <b-form-group
                    id="input-composition"
                    class="col-2"
                    label="Composición"
                    label-for="composition"
                  >
                    <multiselect
                      track-by="value"
                      :class="$v.form.composition.$error ? 'is-invalid' : ''"
                      :multiple="false"
                      :close-on-select="false"
                      :clear-on-select="true"
                      placeholder=""
                      label="text"
                      v-model="$v.form.composition.$model"
                      :options="form.optionsCompositions"
                    >
                    </multiselect>
                  </b-form-group>

                  <b-form-group
                    id="input-image"
                    class="col-3"
                    label="Imagen"
                    description="Dejar vacío para mantener la imagen actual"
                    label-for="image"
                  >
                    <b-form-file
                      accept="image/*"
                      id="image"
                      v-model="$v.form.image.$model"
                      @input="changedImage"
                      :state="validateState('image')"
                      aria-describedby="input-image-feedback"
                      drop-placeholder="Arrastra un archivo aquí..."
                    ></b-form-file>
                    <b-form-invalid-feedback id="input-image-feedback"
                      >Debes seleccionar una imagen válida (formato PNG o
                      JPEG).</b-form-invalid-feedback
                    >
                  </b-form-group>

                  <b-form-group
                    label="Vista previa imagen"
                    id="input-preview"
                    class="col-auto"
                  >
                    <div>
                      <img style="max-height: 5rem" :src="form.imageURI" />
                    </div>
                  </b-form-group>
                </b-form-row>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-form-group
                id="input-weight"
                class="col-2"
                label="Gramaje"
                label-for="weight"
              >
                <b-input-group>
                  <b-form-input
                    id="weight"
                    :value="$v.form.weight.$model.replace('.', ',')"
                    @change="setDecimal('weight', $event)"
                    :state="validateState('weight')"
                    aria-describedby="input-weight-feedback"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>g/m<sup>2</sup></b-input-group-text>
                  </template>
                </b-input-group>
                <b-form-invalid-feedback id="input-weight-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <h4 class="mt-3">Precios</h4>

            <b-form-row>
              <b-form-group
                id="input-meters_per_roll"
                class="col-2"
                label="Metros (por rollo)"
                label-for="meters_per_roll"
              >
                <b-input-group>
                  <b-form-input
                    id="meters_per_roll"
                    :value="$v.form.meters_per_roll.$model.replace('.', ',')"
                    @change="
                      setDecimal('meters_per_roll', $event);
                      calcIncreaseProcessed();
                    "
                    :state="validateState('meters_per_roll')"
                    aria-describedby="input-meters_per_roll-feedback"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>m</b-input-group-text>
                  </template>
                </b-input-group>

                <b-form-invalid-feedback id="input-meters_per_roll-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-cost_roll"
                class="col-2"
                label="Coste (por rollo)"
                label-for="cost_roll"
              >
                <b-input-group>
                  <b-form-input
                    id="cost_roll"
                    :value="$v.form.cost_roll.$model.replace('.', ',')"
                    @change="
                      setDecimal('cost_roll', $event);
                      calcIncreaseProcessed();
                    "
                    :state="validateState('cost_roll')"
                    aria-describedby="input-cost_roll-feedback"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>€</b-input-group-text>
                  </template>
                </b-input-group>

                <b-form-invalid-feedback id="input-cost_roll-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-cost_per_cm"
                class="col-2"
                label="Coste (por centímetro)"
                label-for="cost_per_cm"
              >
                <b-input-group>
                  <b-form-input
                    id="cost_per_cm"
                    :disabled="true"
                    :value="$v.form.cost_per_cm.$model.replace('.', ',')"
                    aria-describedby="input-cost_per_cm-feedback"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>€</b-input-group-text>
                  </template>
                </b-input-group>

                <b-form-invalid-feedback id="input-cost_per_cm-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row class="mt-2 pb-2">
              <b-col cols="2">Incremento sobre coste</b-col>
              <b-col cols="2">Precio (por centímetro)</b-col>
              <b-col cols="2">PVP Euros/metro</b-col>
            </b-form-row>

            <b-form-row class="pb-4">
              <b-col cols="2"
                ><b-form-group
                  id="input-price_increase"
                  class="col-8 pl-0"
                  label-for="price_increase"
                >
                  <b-input-group>
                    <b-form-input
                      id="price_increase"
                      :value="$v.form.price_increase.$model.replace('.', ',')"
                      @change="
                        setDecimal('price_increase', $event);
                        calcIncreaseProcessed();
                      "
                      :state="validateState('price_increase')"
                      aria-describedby="input-price_increase-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>%</b-input-group-text>
                    </template>
                  </b-input-group>

                  <b-form-invalid-feedback id="input-price_increase-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="2"
                ><b-form-group
                  id="input-price_per_meter"
                  class="col-8 pl-0"
                  label-for="price_per_meter"
                  description="IA_PRECIO_TIRA_BORDADA"
                >
                  <b-input-group>
                    <b-form-input
                      id="price_per_meter"
                      :value="$v.form.price_per_meter.$model.replace('.', ',')"
                      :disabled="true"
                      aria-describedby="input-price_per_meter-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>€</b-input-group-text>
                    </template>
                  </b-input-group>

                  <b-form-invalid-feedback id="input-price_per_meter-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>

              <b-col cols="2"
                ><b-form-group
                  id="input-price_per_meter_retail_final"
                  class="col-8 pl-0"
                  label-for="price_per_meter_retail_final"
                >
                  <b-input-group>
                    <b-form-input
                      id="price_per_meter_retail_final"
                      :value="
                        $v.form.price_per_meter_retail_final.$model.replace(
                          '.',
                          ','
                        )
                      "
                      :disabled="true"
                      aria-describedby="input-price_per_meter_retail_final-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>€</b-input-group-text>
                    </template>
                  </b-input-group>

                  <b-form-invalid-feedback
                    id="input-price_per_meter_retail_final-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
            </b-form-row>

            <h4>Otros</h4>

            <b-form-row>
              <b-col :cols="12">
                <b-form-group
                  id="input-has_plane"
                  class="col-8 pl-0"
                  label="Tiene entredós"
                  label-for="has_plane"
                >
                  <b-form-checkbox
                    class="align-middle"
                    switch
                    inline
                    v-model="$v.form.has_plane.$model"
                    name="input-has_plane"
                    >{{
                      $v.form.has_plane.$model ? 'Sí' : 'No'
                    }}</b-form-checkbox
                  >
                </b-form-group>
              </b-col>
            </b-form-row>

            <div class="mt-2" v-if="$v.form.has_plane.$model">
              <h4>Características entredós</h4>

              <b-form-row>
                <b-col cols="12">
                  <b-form-row>
                    <!-- Reference -->
                    <b-form-group
                      id="input-reference"
                      class="col-3"
                      label="Nombre de entredós"
                      label-for="reference"
                    >
                      <b-form-input
                        id="reference"
                        v-model="$v.form.plane_reference.$model"
                        :state="validateState('plane_reference')"
                        aria-describedby="input-reference-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-reference-feedback"
                        >Este campo es obligatorio.</b-form-invalid-feedback
                      >
                    </b-form-group>
                    <b-form-group
                      id="input-provider"
                      class="col-3"
                      label="Proveedor"
                      label-for="provider"
                    >
                      <b-form-input
                        id="provider"
                        v-model="$v.form.plane_provider.$model"
                        :state="validateState('plane_provider')"
                        aria-describedby="input-provider-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-provider-feedback"
                        >Este campo es obligatorio.</b-form-invalid-feedback
                      >
                    </b-form-group>
                    <b-form-group
                      id="input-ref_provider"
                      class="col-3"
                      label="Ref. proveedor"
                      label-for="ref_provider"
                    >
                      <b-form-input
                        id="ref_provider"
                        v-model="$v.form.plane_ref_provider.$model"
                        :state="validateState('plane_ref_provider')"
                        aria-describedby="input-ref_provider-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-ref_provider-feedback"
                        >Este campo es obligatorio.</b-form-invalid-feedback
                      >
                    </b-form-group>
                  </b-form-row>
                  <b-form-row>
                    <!-- Medidas -->

                    <b-form-group
                      id="input-rapport_width"
                      class="col-4"
                      label="Medidas rapport (Ancho x Largo)"
                      label-for="rapport_width"
                    >
                      <b-form-row>
                        <b-col :cols="6">
                          <b-input-group>
                            <b-form-input
                              id="rapport_width"
                              :value="
                                $v.form.plane_rapport_width.$model.replace(
                                  '.',
                                  ','
                                )
                              "
                              @change="
                                setDecimal('plane_rapport_width', $event)
                              "
                              :state="validateState('plane_rapport_width')"
                              aria-describedby="input-rapport_width-feedback"
                            ></b-form-input>
                            <template #append>
                              <b-input-group-text>cm</b-input-group-text>
                            </template>
                          </b-input-group>
                          <b-form-invalid-feedback
                            id="input-rapport_width-feedback"
                            >Este campo es obligatorio.</b-form-invalid-feedback
                          >
                        </b-col>
                        <b-col :cols="6">
                          <b-input-group>
                            <b-form-input
                              id="rapport_long"
                              :value="
                                $v.form.plane_rapport_long.$model.replace(
                                  '.',
                                  ','
                                )
                              "
                              @change="setDecimal('plane_rapport_long', $event)"
                              :state="validateState('plane_rapport_long')"
                              aria-describedby="input-rapport_long-feedback"
                            ></b-form-input>
                            <template #append>
                              <b-input-group-text>cm</b-input-group-text>
                            </template>
                          </b-input-group>
                          <b-form-invalid-feedback
                            id="input-rapport_long-feedback"
                            >Este campo es obligatorio.</b-form-invalid-feedback
                          >
                        </b-col>
                      </b-form-row>
                    </b-form-group>
                    <b-form-group
                      id="input-plane_composition"
                      class="col-2"
                      label="Composición"
                      label-for="plane_composition"
                    >
                      <multiselect
                        track-by="value"
                        :class="
                          $v.form.plane_composition.$error ? 'is-invalid' : ''
                        "
                        :multiple="false"
                        :close-on-select="false"
                        :clear-on-select="true"
                        placeholder=""
                        label="text"
                        v-model="$v.form.plane_composition.$model"
                        :options="form.optionsCompositions"
                      >
                      </multiselect>
                    </b-form-group>

                    <b-form-group
                      id="input-plane_image"
                      class="col-3"
                      label="Imagen"
                      description="Dejar vacío para mantener la imagen actual"
                      label-for="plane_image"
                    >
                      <b-form-file
                        accept="image/*"
                        id="plane_image"
                        v-model="$v.form.plane_image.$model"
                        @input="changedImagePlane"
                        :state="validateState('plane_image')"
                        aria-describedby="input-plane_image-feedback"
                        drop-placeholder="Arrastra un archivo aquí..."
                      ></b-form-file>
                      <b-form-invalid-feedback id="input-plane_image-feedback"
                        >Debes seleccionar una imagen válida (formato PNG o
                        JPEG).</b-form-invalid-feedback
                      >
                    </b-form-group>

                    <b-form-group
                      label="Vista previa imagen"
                      id="input-preview"
                      class="col-auto"
                    >
                      <div>
                        <img
                          style="max-height: 5rem"
                          :src="form.plane_imageURI"
                        />
                      </div>
                    </b-form-group>
                  </b-form-row>
                </b-col>
              </b-form-row>

              <b-form-row>
                <b-form-group
                  id="input-plane_weight"
                  class="col-2"
                  label="Gramaje"
                  label-for="plane_weight"
                >
                  <b-input-group>
                    <b-form-input
                      id="plane_weight"
                      :value="$v.form.plane_weight.$model.replace('.', ',')"
                      @change="setDecimal('plane_weight', $event)"
                      :state="validateState('plane_weight')"
                      aria-describedby="input-plane_weight-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>g/m<sup>2</sup></b-input-group-text>
                    </template>
                  </b-input-group>
                  <b-form-invalid-feedback id="input-plane_weight-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-form-row>

              <h4 class="mt-3">Precios</h4>

              <b-form-row>
                <b-form-group
                  id="input-plane_meters_per_roll"
                  class="col-2"
                  label="Metros (por rollo)"
                  label-for="plane_meters_per_roll"
                >
                  <b-input-group>
                    <b-form-input
                      id="plane_meters_per_roll"
                      :value="
                        $v.form.plane_meters_per_roll.$model.replace('.', ',')
                      "
                      @change="
                        setDecimal('plane_meters_per_roll', $event);
                        calcIncreasePlaneProcessed();
                      "
                      :state="validateState('plane_meters_per_roll')"
                      aria-describedby="input-plane_meters_per_roll-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>m</b-input-group-text>
                    </template>
                  </b-input-group>

                  <b-form-invalid-feedback
                    id="input-plane_meters_per_roll-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group>

                <b-form-group
                  id="input-plane_cost_roll"
                  class="col-2"
                  label="Coste (por rollo)"
                  label-for="plane_cost_roll"
                >
                  <b-input-group>
                    <b-form-input
                      id="plane_cost_roll"
                      :value="$v.form.plane_cost_roll.$model.replace('.', ',')"
                      @change="
                        setDecimal('plane_cost_roll', $event);
                        calcIncreasePlaneProcessed();
                      "
                      :state="validateState('plane_cost_roll')"
                      aria-describedby="input-plane_cost_roll-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>€</b-input-group-text>
                    </template>
                  </b-input-group>

                  <b-form-invalid-feedback id="input-plane_cost_roll-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group>

                <b-form-group
                  id="input-plane_cost_per_cm"
                  class="col-2"
                  label="Coste (por centímetro)"
                  label-for="plane_cost_per_cm"
                >
                  <b-input-group>
                    <b-form-input
                      id="plane_cost_per_cm"
                      :disabled="true"
                      :value="
                        $v.form.plane_cost_per_cm.$model.replace('.', ',')
                      "
                      aria-describedby="input-plane_cost_per_cm-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>€</b-input-group-text>
                    </template>
                  </b-input-group>

                  <b-form-invalid-feedback id="input-plane_cost_per_cm-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-form-row>

              <b-form-row class="mt-2 pb-2">
                <b-col cols="2">Incremento sobre coste</b-col>
                <b-col cols="2">Precio (por centímetro)</b-col>
                <b-col cols="2">PVP Euros/metro</b-col>
              </b-form-row>

              <b-form-row class="pb-4">
                <b-col cols="2"
                  ><b-form-group
                    id="input-plane_price_increase"
                    class="col-8 pl-0"
                    label-for="plane_price_increase"
                  >
                    <b-input-group>
                      <b-form-input
                        id="plane_price_increase"
                        :value="
                          $v.form.plane_price_increase.$model.replace('.', ',')
                        "
                        @change="
                          setDecimal('plane_price_increase', $event);
                          calcIncreasePlaneProcessed();
                        "
                        :state="validateState('plane_price_increase')"
                        aria-describedby="input-plane_price_increase-feedback"
                      ></b-form-input>
                      <template #append>
                        <b-input-group-text>%</b-input-group-text>
                      </template>
                    </b-input-group>

                    <b-form-invalid-feedback
                      id="input-plane_price_increase-feedback"
                      >Este campo es obligatorio.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col cols="2"
                  ><b-form-group
                    id="input-plane_price_per_meter"
                    class="col-8 pl-0"
                    label-for="plane_price_per_meter"
                    description="IA_PRECIO_ENTREDOS"
                  >
                    <b-input-group>
                      <b-form-input
                        id="plane_price_per_meter"
                        :value="
                          $v.form.plane_price_per_meter.$model.replace('.', ',')
                        "
                        :disabled="true"
                        aria-describedby="input-plane_price_per_meter-feedback"
                      ></b-form-input>
                      <template #append>
                        <b-input-group-text>€</b-input-group-text>
                      </template>
                    </b-input-group>

                    <b-form-invalid-feedback
                      id="input-plane_price_per_meter-feedback"
                      >Este campo es obligatorio.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>

                <b-col cols="2"
                  ><b-form-group
                    id="input-plane_price_per_meter_retail_final"
                    class="col-8 pl-0"
                    label-for="plane_price_per_meter_retail_final"
                  >
                    <b-input-group>
                      <b-form-input
                        id="plane_price_per_meter_retail_final"
                        :value="
                          $v.form.plane_price_per_meter_retail_final.$model.replace(
                            '.',
                            ','
                          )
                        "
                        :disabled="true"
                        aria-describedby="input-plane_price_per_meter_retail_final-feedback"
                      ></b-form-input>
                      <template #append>
                        <b-input-group-text>€</b-input-group-text>
                      </template>
                    </b-input-group>

                    <b-form-invalid-feedback
                      id="input-plane_price_per_meter_retail_final-feedback"
                      >Este campo es obligatorio.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
              </b-form-row>
            </div>

            <b-button type="submit" variant="primary"
              >Guardar nueva tira bordada</b-button
            >
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  required,
  decimal,
  minValue,
  requiredIf,
} from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import { helpers } from 'vuelidate/lib/validators';

import * as Sentry from '@sentry/browser';

import Multiselect from 'vue-multiselect';

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

const isValidImage = (image) =>
  !helpers.req(image) || ['image/jpeg', 'image/png'].includes(image['type']);

export default {
  name: 'AdminEmbroideredStripsEditScreen',
  props: ['id'],
  components: { Multiselect, VueCropper },
  mixins: [validationMixin],
  validations() {
    let rules = {
      reference: { required },

      provider: { required },
      ref_provider: { required },
      rapport_width: {},
      rapport_long: {},
      composition: {},
      image: {
        isValidImage,
      },
      weight: {},

      meters_per_roll: {},
      cost_roll: {},
      cost_per_cm: {},
      price_increase: {},
      price_per_meter: {},
      price_per_meter_retail_final: {},

      has_plane: { required },

      plane_reference: {
        required: requiredIf(function (form) {
          return form.has_plane;
        }),
      },
      plane_provider: {
        required: requiredIf(function (form) {
          return form.has_plane;
        }),
      },
      plane_ref_provider: {
        required: requiredIf(function (form) {
          return form.has_plane;
        }),
      },
      plane_rapport_width: {},
      plane_rapport_long: {},
      plane_composition: {},
      plane_image: {
        isValidImage,
      },

      plane_weight: {},

      plane_meters_per_roll: {},
      plane_cost_roll: {},
      plane_cost_per_cm: {},
      plane_price_increase: {},
      plane_price_per_meter: {},
      plane_price_per_meter_retail_final: {},
      /*cost: {
        required,
        decimal,
        minValue: minValue(0.0),
      },*/
    };

    // this.languageCodes.map((x) => {
    //   rules['name_' + x] = { required };
    // });

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      reference: '',
      provider: '',
      ref_provider: '',
      rapport_width: '',
      rapport_long: '',
      composition: null,
      image: null,
      imageURI: null,

      weight: '',

      meters_per_roll: '',
      cost_roll: '',
      cost_per_cm: '',
      price_increase: '',
      price_per_meter: '',
      price_per_meter_retail_final: '',

      has_plane: false,

      plane_reference: '',
      plane_provider: '',
      plane_ref_provider: '',
      plane_rapport_width: '',
      plane_rapport_long: '',
      plane_composition: null,
      plane_image: null,
      plane_imageURI: null,
      plane_meters_per_roll: '',
      plane_cost_roll: '',
      plane_cost_per_cm: '',
      plane_price_increase: '',
      plane_price_per_meter: '',
      plane_price_per_meter_retail_final: '',

      plane_weight: '',

      error: {
        show: false,
        text: '',
      },
      optionsCompositions: [],
      optionsColorFamilies: [],
      optionsDesigns: [],
    };

    // store.getLanguageCodes().map((x) => {
    //   form['name_' + x] = '';
    // });

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes().filter((x) => x == 'es'),
      languageNames: store.getLanguageNames(),
      form: form,
    };
  },
  created() {
    let preloadPromises = [];

    preloadPromises.push(
      actions.getFabricCompositions(),
      actions.getFabricColorFamilies(),
      actions.getFabricDesigns()
    );

    Promise.all(preloadPromises).then((z) => {
      this.form.optionsCompositions = z[0].data.results.map((y) => {
        return {
          value: y.id,
          text: y.name,
        };
      });

      if (this.id !== 'new') {
        actions.getEmbroideredStrip(this.id).then((x) => {
          const data = x.data;

          this.form.reference = data.reference;
          this.form.provider = data.provider;
          this.form.ref_provider = data.ref_provider;

          this.form.imageURI = data.image;

          this.form.rapport_width = data.rapport_width
            ? data.rapport_width
            : '';
          this.form.rapport_long = data.rapport_long ? data.rapport_long : '';

          if (data.composition.length > 0) {
            this.form.composition = this.form.optionsCompositions.find((y) =>
              data.composition.includes(y.value)
            );
          }

          this.form.weight = data.weight ? data.weight : '';
          this.form.meters_per_roll = data.meters_per_roll
            ? data.meters_per_roll
            : '';
          this.form.cost_roll = data.cost_roll ? data.cost_roll : '';
          this.form.cost_per_cm = data.cost_per_cm ? data.cost_per_cm : '';
          this.form.price_increase = data.price_increase
            ? data.price_increase
            : '';
          this.form.price_per_meter = data.price_per_meter
            ? data.price_per_meter
            : '';
          this.form.price_per_meter_retail_final = data.price_per_meter_retail_final
            ? data.price_per_meter_retail_final
            : '';

          this.form.has_plane = data.has_plane;

          this.form.plane_reference = data.plane_reference;
          this.form.plane_provider = data.plane_provider;
          this.form.plane_ref_provider = data.plane_ref_provider;

          this.form.plane_imageURI = data.plane_image;

          this.form.plane_rapport_width = data.plane_rapport_width
            ? data.plane_rapport_width
            : '';
          this.form.plane_rapport_long = data.plane_rapport_long
            ? data.plane_rapport_long
            : '';

          if (data.plane_composition.length > 0) {
            this.form.plane_composition = this.form.optionsCompositions.find(
              (y) => data.plane_composition.includes(y.value)
            );
          }

          this.form.plane_weight = data.plane_weight ? data.plane_weight : '';

          this.form.plane_meters_per_roll = data.plane_meters_per_roll
            ? data.plane_meters_per_roll
            : '';
          this.form.plane_cost_roll = data.plane_cost_roll
            ? data.plane_cost_roll
            : '';
          this.form.plane_cost_per_cm = data.plane_cost_per_cm
            ? data.plane_cost_per_cm
            : '';
          this.form.plane_price_increase = data.plane_price_increase
            ? data.plane_price_increase
            : '';
          this.form.plane_price_per_meter = data.plane_price_per_meter
            ? data.plane_price_per_meter
            : '';
          this.form.plane_price_per_meter_retail_final = data.plane_price_per_meter_retail_final
            ? data.plane_price_per_meter_retail_final
            : '';
        });
      }
    });
  },
  methods: {
    getDataURIFromFile(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.readAsDataURL(file);
      });
    },
    changedImage(newFile) {
      this.getDataURIFromFile(newFile).then((result) => {
        this.form.imageURI = result;
      });
    },
    changedImagePlane(newFile) {
      this.getDataURIFromFile(newFile).then((result) => {
        this.form.plane_imageURI = result;
      });
    },
    setDecimal(name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form[name].$model = val;
      this.$v.form[name].$touch();
    },

    calcIncreaseProcessed() {
      if (
        parseFloat(this.$v.form['meters_per_roll'].$model) > 0 &&
        parseFloat(this.$v.form['cost_roll'].$model) > 0
      ) {
        this.$v.form['cost_per_cm'].$model = (
          parseFloat(this.$v.form['cost_roll'].$model) /
          parseFloat(this.$v.form['meters_per_roll'].$model * 100.0)
        ).toFixed(4);
      }

      if (
        parseFloat(this.$v.form['cost_per_cm'].$model) > 0 &&
        parseFloat(this.$v.form['price_increase'].$model) > 0
      ) {
        this.$v.form['price_per_meter'].$model = (
          parseFloat(this.$v.form['cost_per_cm'].$model) *
          (1 + parseFloat(this.$v.form['price_increase'].$model) / 100.0)
        ).toFixed(4);
      }

      if (parseFloat(this.$v.form['price_per_meter'].$model) > 0) {
        this.$v.form['price_per_meter_retail_final'].$model = (
          parseFloat(this.$v.form['price_per_meter'].$model) * 1.21
        ).toFixed(4);
      }
    },

    calcIncreasePlaneProcessed() {
      if (
        parseFloat(this.$v.form['plane_meters_per_roll'].$model) > 0 &&
        parseFloat(this.$v.form['plane_cost_roll'].$model) > 0
      ) {
        this.$v.form['plane_cost_per_cm'].$model = (
          parseFloat(this.$v.form['plane_cost_roll'].$model) /
          parseFloat(this.$v.form['plane_meters_per_roll'].$model * 100.0)
        ).toFixed(4);
      }

      if (
        parseFloat(this.$v.form['plane_cost_per_cm'].$model) > 0 &&
        parseFloat(this.$v.form['plane_price_increase'].$model) > 0
      ) {
        this.$v.form['plane_price_per_meter'].$model = (
          parseFloat(this.$v.form['plane_cost_per_cm'].$model) *
          (1 + parseFloat(this.$v.form['plane_price_increase'].$model) / 100.0)
        ).toFixed(4);
      }

      if (parseFloat(this.$v.form['plane_price_per_meter'].$model) > 0) {
        this.$v.form['plane_price_per_meter_retail_final'].$model = (
          parseFloat(this.$v.form['plane_price_per_meter'].$model) * 1.21
        ).toFixed(4);
      }
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      store.setOverlayShow(true);

      let data = new FormData();

      data.append('reference', this.form.reference);
      data.append('provider', this.form.provider);
      data.append('ref_provider', this.form.ref_provider);
      data.append('rapport_width', this.form.rapport_width);
      data.append('rapport_long', this.form.rapport_long);

      data.append(
        'composition',
        JSON.stringify(
          this.form.composition ? [this.form.composition.value] : []
        )
      );

      if (this.form.image !== null) {
        data.append('image', this.form.image);
      }

      data.append('weight', this.form.weight);
      data.append('meters_per_roll', this.form.meters_per_roll);
      data.append('cost_roll', this.form.cost_roll);
      data.append('cost_per_cm', this.form.cost_per_cm);

      data.append('price_increase', this.form.price_increase);
      data.append('price_per_meter', this.form.price_per_meter);
      data.append(
        'price_per_meter_retail_final',
        this.form.price_per_meter_retail_final
      );

      data.append('has_plane', this.form.has_plane);
      data.append('plane_reference', this.form.plane_reference);
      data.append('plane_provider', this.form.plane_provider);

      data.append('plane_ref_provider', this.form.plane_ref_provider);
      data.append('plane_rapport_width', this.form.plane_rapport_width);
      data.append('plane_rapport_long', this.form.plane_rapport_long);

      data.append(
        'plane_composition',
        JSON.stringify(
          this.form.plane_composition ? [this.form.plane_composition.value] : []
        )
      );

      if (this.form.plane_image !== null) {
        data.append('plane_image', this.form.plane_image);
      }

      data.append('plane_weight', this.form.plane_weight);
      data.append('plane_meters_per_roll', this.form.plane_meters_per_roll);
      data.append('plane_cost_roll', this.form.plane_cost_roll);
      data.append('plane_cost_per_cm', this.form.plane_cost_per_cm);

      data.append('plane_price_increase', this.form.plane_price_increase);
      data.append('plane_price_per_meter', this.form.plane_price_per_meter);
      data.append(
        'plane_price_per_meter_retail_final',
        this.form.plane_price_per_meter_retail_final
      );

      // data.append('cost', this.form.cost);

      // this.languageCodes.map((x) => {
      //   data.append('name_' + x, this.form['name_' + x]);
      // });

      // data.append('name', this.form['name_' + this.languageCodes[0]]);

      Sentry.setExtra('data', JSON.stringify(Object.fromEntries(data)));

      if (this.id === 'new') {
        actions.postEmbroideredStrip(data).then((x) => {
          this.$router.push({ name: 'AdminEmbroideredStripsScreen' });
        });
      } else {
        actions.patchEmbroideredStrip(this.id, data).then((x) => {
          this.$router.push({ name: 'AdminEmbroideredStripsScreen' });
        });
      }
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
